<form class="add-document-form" [formGroup]="taskManagementService.TaskManagementForm" role="form" autocomplete="off">

    <mat-progress-spinner
        *ngIf="isLoading"
        mode="indeterminate"
        diameter="40"
        class="spinner-overlay">
    </mat-progress-spinner>

    <!-- <p>myForm value: {{ taskManagementService.TaskManagementForm.value | json }}</p> -->
    <mat-form-field class="example-full-width tarea-field" floatLabel="always"
        [ngClass]="{ 'form-validator-message-text' : taskManagementService.TaskManagementForm.get('Tarea').touched && taskManagementService.TaskManagementForm.get('Tarea').invalid }">
        <mat-label>Tarea</mat-label>
        <mat-select formControlName="Tarea" (selectionChange)="onTaskChange($event)">
            <mat-option *ngFor="let option of taskList" [value]="option.id">
                {{option.texto}}
            </mat-option>
        </mat-select>
        <mat-error
            *ngIf="taskManagementService.TaskManagementForm.get('Tarea') && taskManagementService.TaskManagementForm.get('Tarea').invalid">
            <span
                *ngIf="taskManagementService.TaskManagementForm.get('Tarea') && taskManagementService.TaskManagementForm.get('Tarea').errors.required"
                class="validation-span">Obligatorio</span>
        </mat-error>
    </mat-form-field>

    <!-- <app-author *ngIf="isShowAutor" [authorFormGroup]="taskManagementService.TaskManagementForm.get('Author')"
        [tipoAutor]="taskManagementService.SelectedTask ? taskManagementService.SelectedTask.tipoAutor: null"
        [authComponentModel]="authComponentModel">
    </app-author> -->

    <app-globle-author *ngIf="isShowAutor" [LeaveInfo]="LeaveInfo"  [citarBajaNueva]="taskManagementService.citarBajaNueva" [bajaNueva]="taskManagementService.bajaNueva" [authorFormGroup]="taskManagementService.TaskManagementForm.get('Author')"  [moduleName]="responsibleModuleName" [authorTypes]="responsibleAuthorTypes" [authComponentModel]="authComponentModel">
    </app-globle-author>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
        <div class="widget" fxFlex="100" fxFlex.gt-sm="33">
            <mat-form-field class="example-full-width date required-date-field minwidth100" floatLabel="always" [ngClass]="{'required-validation form-validator-message-text': taskManagementService.TaskManagementForm.get('Fecha').touched && taskManagementService.TaskManagementForm.get('Fecha').errors !== null
            && taskManagementService.TaskManagementForm.get('Fecha').errors.required}">
                <mat-label>Fecha</mat-label>
                <input matInput formControlName="Fecha" [matDatepicker]="TaskDate" (click)="TaskDate.open()"
                    [min]="todayDate">
                <mat-datepicker-toggle matSuffix [for]="TaskDate"></mat-datepicker-toggle>
                <mat-datepicker #TaskDate></mat-datepicker>
                <mat-error *ngIf="(taskManagementService.TaskManagementForm.get('Fecha').dirty || taskManagementService.TaskManagementForm.get('Fecha').touched) 
                    && taskManagementService.TaskManagementForm.get('Fecha').invalid">
                    <span
                        *ngIf="taskManagementService.TaskManagementForm.get('Fecha') && taskManagementService.TaskManagementForm.get('Fecha').errors.required"
                        class="validation-span">Obligatorio</span>
                </mat-error>
            </mat-form-field>

        </div>
        <div class="widget m-l-10" fxFlex="100" fxFlex.gt-sm="33">
            <mat-form-field class="example-full-width time minwidth100" floatLabel="always">
                <mat-label>Hora</mat-label>
                <input matInput type="time" placeholder="Hora" formControlName="Hora">
            </mat-form-field>
        </div>
        <div class="widget  checkbx-sme" fxFlex="100" fxFlex.gt-sm="33">
            <mat-checkbox class="m-r-10" formControlName="TaskService" *ngIf="isShowSme">SME
            </mat-checkbox>
        </div>

    </div>
    <mat-form-field class="example-full-width obs" floatLabel="always">
        <mat-label>Observaciones</mat-label>
        <input matInput formControlName="Observation">
                <mat-error *ngIf="taskManagementService.TaskManagementForm.get('Observation').touched || taskManagementService.TaskManagementForm.get('Observation').dirty" >
                    <span *ngIf="taskManagementService.TaskManagementForm.get('Observation').errors?.maxlength"  class="validation-span">
                        La longitud máxima de caracteres es 250
                    </span>
                </mat-error>
    </mat-form-field>

</form>